import React from 'react'
import {Check, Sparkles} from 'lucide-react'

export default function Advantages() {
  const advantages = [
    'Meilleurs prix garantis grâce à notre réseau',
    'Accompagnement personnalisé de A à Z',
    'Démarches administratives simplifiées',
    'Livraison partout en France',
    'Service après-vente réactif',
    'Reprise de votre ancien véhicule',
    'Solutions de financement adaptées',
    'Garantie constructeur incluse'
  ]

  return (
    <section className="bg-zinc-950 py-16 sm:py-20 md:py-24 relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-red-500/10 rounded-full blur-3xl" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
          <div className="inline-flex items-center gap-2 bg-blue-600/20 backdrop-blur-sm border border-blue-400/30 px-4 sm:px-6 py-2.5 sm:py-3 rounded-full mb-4 sm:mb-6">
            <Sparkles className="text-blue-400 flex-shrink-0" size={18} />
            <span className="text-white font-medium text-sm sm:text-base">Nos atouts</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 px-4 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
            Pourquoi choisir <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-white to-red-500">AUTO STAR</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 animate-in fade-in slide-in-from-bottom-8 duration-700" style={{ animationDelay: '0.2s' }}>
          {advantages.map((advantage, idx) => (
            <div 
              key={idx}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 hover:bg-white/10 hover:border-blue-400/30 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-blue-500/10"
            >
              <div className="flex items-start gap-3">
                <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-full p-1.5 group-hover:scale-110 transition-transform duration-300 flex-shrink-0 mt-0.5">
                  <Check className="text-white" size={16} strokeWidth={3} />
                </div>
                <p className="text-white/90 font-medium leading-relaxed text-xs sm:text-sm md:text-base" style={{ fontFamily: 'Outfit, sans-serif' }}>{advantage}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
